<script>
  export let imageSrc = "";
  export let title = "";
  export let description = "";
  export let leftBullets = []; // array of strings for left column
  export let rightBullets = []; // array of strings for right column
  export let alt = "Service illustration";
</script>

<div
  class="
    flex flex-col md:flex-row md:items-start
    gap-6 lg:gap-10
    w-full max-w-[1200px] mx-auto
    p-6 md:p-8
    bg-blue-50
    rounded-xl
    shadow-md
    overflow-hidden
  "
>
  <!-- Left side: title + description + two-column bullets -->
  <div class="flex-1 space-y-5 md:space-y-6 text-center md:text-left">
    {#if title}
      <h3 class="text-2xl md:text-3xl font-bold text-gray-900 leading-tight">
        {title}
      </h3>
    {/if}

    {#if description}
      <p
        class="text-base md:text-lg text-gray-700 whitespace-pre-line leading-relaxed"
      >
        {description}
      </p>
    {/if}

    {#if leftBullets?.length || rightBullets?.length}
      <div
        class="grid grid-cols-1 md:grid-cols-2 gap-x-8 lg:gap-x-12 gap-y-3.5 pt-2"
      >
        <!-- Left column -->
        <div class="space-y-1">
          {#each leftBullets as bullet}
            <div class="flex items-start gap-3">
              <span
                class="text-gray-700 text-base leading-relaxed whitespace-pre-wrap"
              >
                {bullet}
              </span>
            </div>
          {/each}
        </div>

        <!-- Right column -->
        <div class="space-y-1">
          {#each rightBullets as bullet}
            <div class="flex items-start gap-3">
              <span
                class="text-gray-700 text-base leading-relaxed whitespace-pre-wrap"
              >
                {bullet}
              </span>
            </div>
          {/each}
        </div>
      </div>
    {/if}
  </div>

  <!-- Right side: image -->
  {#if imageSrc}
    <div class="flex justify-center md:justify-end shrink-0 mt-6 md:mt-0">
      <img
        src={imageSrc}
        {alt}
        class="
          w-full max-w-[260px] md:max-w-[320px] lg:max-w-[360px]
          h-auto
          rounded-xl
          object-cover
          md:object-contain
        "
        width="360"
        height="280"
        loading="lazy"
      />
    </div>
  {/if}
</div>
